var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('Pointer'),(_vm.consultWarehouse())?_c('SelectWarehouse'):_vm._e(),(_vm.own_inventory_count_mode)?_c('CountInventory'):_vm._e(),(_vm.own_inventory_count_review)?_c('CountReview'):_vm._e(),(_vm.own_inventory_online_mode)?_c('OnlineInventory'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }